import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = (event) => {
    const itemCount = event?.detail?.data?.itemCount;
    if (typeof itemCount === 'number') {
      this.refs.dialog.classList.toggle('cart-drawer--empty', itemCount === 0);
    }

    // Ensure the drawer's own section content is fresh before/while opening.
    // Without this, the dialog can open showing whatever HTML was rendered
    // at page load (e.g. the empty-cart markup), since CartAddEvent alone
    // never triggers cart-items-component's own re-render logic.
    const cartItemsComponent = this.querySelector('cart-items-component');
    if (cartItemsComponent instanceof HTMLElement && cartItemsComponent.dataset.sectionId) {
      sectionRenderer.renderSection(cartItemsComponent.dataset.sectionId, { cache: false });
    }

    if (this.hasAttribute('auto-open')) {
      this.open();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}